import './AboutSection.css';
import pcSoftLogo from '../assets/images/logo-pcsoft-b.png';

function AboutSection() {
  return (
    <section className="about" id="apropos">
      <div className="about__layout">
        <article className="about__card section-card">
          <div className="section-heading">
            <span className="section-eyebrow">À propos</span>
            <h2 className="section-title">Qui je suis</h2>
            <p className="section-copy">
              Développeur autodidacte, je travaille sur l'évolution d’ERP complexes et sur la création d'applications.
              J’aime les projets ambitieux, les défis techniques et les interfaces soignées.
            </p>
            <p className="section-copy">
              J’interviens sur des environnements exigeants avec une attention particulière sur la performance,
              la fiabilité et la maintenabilité.
            </p>
            <p className="section-copy">
              Je développe aussi mes compétences web (ce site en est un exemple) et apprécie les
              défis comme les Rubik’s Cubes.
            </p>
          </div>
        </article>

        <aside className="about__side section-card">

          <div className="about__cube" aria-hidden="true">
            <div className="about__cube-face about__cube-face--front" />
            <div className="about__cube-face about__cube-face--back" />
            <div className="about__cube-face about__cube-face--right" />
            <div className="about__cube-face about__cube-face--left" />
            <div className="about__cube-face about__cube-face--top" />
            <div className="about__cube-face about__cube-face--bottom" />
          </div>
          <div className="about__quote ">
            “Relever des défis techniques complexes et m’adapter à des contextes clients exigeants.”
          </div>
        </aside>
      </div>
    </section>
  );
}

export default AboutSection;
